<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <v-row align="center" justify="center" outlined align-content="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12 mx-auto" :loading="!isAuthChecked">
              <v-card-title>{{cardTitle }}</v-card-title>
              <v-card-subtitle>{{cardSubTitle}}</v-card-subtitle>

              <v-card-text >
                <p>{{cardText}}</p>

                                <v-avatar v-if="isAuthChecked && isAuthChecked" color="red">
                  <img v-if="user.attributes && user.attributes.picture" :src="user.attributes.picture" />
                  <span v-else class="white--text headline">{{ initials }}</span>
                </v-avatar>
                Your MFA Option: {{mfa}}
                <qrcode v-if="qrCode" :value="qrCode" :options="{ width: 400 }"></qrcode>
                <v-text-field v-if="qrCode" v-model="challengeAnswer" hint="Challenge answer" placeholder="Add the QR code to your app, then enter the code"></v-text-field>
                  <v-btn v-if="qrCode" :disabled="!challengeAnswer" @click="verifyOtp()">Verify OTP</v-btn>

              </v-card-text>


              <v-card-actions>
                    <v-btn to="/" left>Back to Home</v-btn>
                    <v-spacer />
                    <v-btn v-if="isAuthChecked && isAuthenticated"
                      @click="setupOtp()"
                      color="normal">Setup Software MFA Token</v-btn>
                    <v-btn right
                      v-if="isAuthChecked && isAuthenticated"
                      @click="signOut()"
                      color="warning"
                      :loading="signingOut"
                    >Sign Out</v-btn>
                    <v-btn right
                      v-if="!isAuthChecked || !isAuthenticated"
                      @click="signInGoogle()"
                      color="primary"
                      :loading="signingIn"
                    >Sign In with Google</v-btn>
                    <!--
                    <v-btn right
                      v-if="!isAuthChecked || !isAuthenticated"
                      @click="signIn()"
                      color="primary"
                      :loading="signingIn"
                    >Sign In</v-btn>
                    -->
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import Vue from "vue";

import VueQrcode from '@chenfengyuan/vue-qrcode';

Vue.component(VueQrcode.name, VueQrcode);

export default {
  computed: {
    cardTitle: function () {
      if (!this.isAuthChecked) {
        return "Checking your credentials";
      } else {
        if (this.isAuthenticated) {
          return `Hi ${this.user.attributes["given_name"]}`;
        } else {
          return "Hi there";
        }
      }
    },
    cardSubTitle: function () {
      if (!this.isAuthChecked) {
        return "One moment please.";
      } else {
        return "";
      }
    },
    cardText: function () {
      if (this.isAuthChecked && !this.isAuthenticated) {
        return "There is a problem with your credentials.";
      }
      return "";
    },
    initials: function () {
      return `${this.user.attributes["given_name"].charAt(0)}${this.user.attributes["family_name"].charAt(0)}`;
    },
  },
  async created() {
    const user = await this.getUser();
    this.isAuthChecked = true;
    if (!this.isAuthenticated) {
      this.signIn();
      //this.signInGoogle();
    }
  },
  beforeDestroy() {},
  data: () => {
    return {
      user: {},
      isAuthenticated: false,
      isAuthChecked: false,
      signingOut: false,
      signingIn: false,
      mfaTypes: {
        SMS:true,
        TOTP:true,
        Optional:true
      },
      authData: {},
      mfa: {},
      qrCode: "",
      challengeAnswer: ""
    };
  },
  methods: {
    getUser: async function () {
      {
        try {
          const user = await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
          if (user && user.signInUserSession) {
            //console.log("getUser got user");
            this.user = user;
            this.isAuthenticated = true;

            const mfa = await Vue.prototype.$Amplify.Auth.getPreferredMFA(user);

            console.log('getmfa response', mfa);
            this.mfa = mfa;


          } else {
            console.log("getUser user invalid");
            this.user = user;
            this.isAuthenticated = false;
          }
        } catch (err) {
          console.log("getUser err", err);
          this.user = {};
          this.isAuthenticated = false;
        }
      }
    },
    signIn: async function () {
      this.singingIn = true;
      Vue.prototype.$Amplify.Auth.federatedSignIn();
      this.singingIn = false;
    },signInGoogle: async function () {
      this.singingIn = true;
      Vue.prototype.$Amplify.Auth.federatedSignIn({provider:'Google'});
      this.singingIn = false;
    },
    setupOtp: async function() {
      this.qrCode = "";
      try {
        const code = await Vue.prototype.$Amplify.Auth.setupTOTP(this.user);
        const issuer = encodeURIComponent("1stGroup Hub Console Login " + (process.env.VUE_APP_ENV_LABEL || "").trim());
        const str = `otpauth://totp/AWSCognito:${this.user.username}?secret=${code}&issuer=${issuer}`;
        console.log("setting otp qrcode to", str)
        this.qrCode = str;
      }
      catch (err) {
        this.$dialog.error({
          text: JSON.stringify(err),
          title: "Cannot setup OTP",
          icon: "mdi-error",
        });
        console.log(err);
        this.qrCode = "";
      }
    },
    verifyOtp: async function() {
      try {
        const result = await Vue.prototype.$Amplify.Auth.verifyTotpToken(this.user, this.challengeAnswer);
        console.log("verifyOtp got result", result);
        const pmfaResult = await Vue.prototype.$Amplify.Auth.setPreferredMFA(this.user, 'TOTP');
        console.log("setPreferredMFA got result", pmfaResult);
        const mfa = await Vue.prototype.$Amplify.Auth.getPreferredMFA(this.user);
        this.mfa = mfa;
        this.qrCode = "";
        this.challengeAnswer = "";
      }
      catch (err) {
        this.$dialog.error({
          text: JSON.stringify(err),
          title: "Cannot verify OTP",
          icon: "mdi-error",
        });
        console.log(err);
      }
    },

    signOut: async function () {
      this.singingOut = true;
      await Vue.prototype.$Amplify.Auth.signOut();
      this.user = {};
      this.isAuthenticated = false;
      console.log("Signed out");
      this.signingOut = false;
    },
  },
};
</script>
